import { get } from 'lodash';
import React from 'react';
import { Td, Tr, Th, Table, TdImp, HorizontalContent, TdLabel } from './css';
import FormSummaryRow from '../../formSummaryRow';
import { formatCurrency } from '../../../utils/currencyFormatter';

const Services = ({ formFields, orderData }) => {
  return formFields.map(({ fields }) => {
    if (fields.type === 'ServiceTable') {
      const { categoryName, subCategoryName } = fields.customConfigurations;
      const products = get(
        orderData.products,
        `${[categoryName]}.${[subCategoryName]}`,
        []
      );
      return (
        <>
          <Table>
            <Th style={{ width: '40%' }}>{subCategoryName}</Th>
            <Th>One-Time Pricing (per Qty)</Th>
            <Th>Recurring Price (per Qty)</Th>
            <Th>Quantity</Th>
            {products.map(
              ({ name, price, quantity, priceType, isMandatory }, idx) => {
                return (
                  <Tr>
                    <Td>
                      {name} {isMandatory ? '*' : ''}
                    </Td>
                    {priceType === 'recurring' ? (
                      <TdImp />
                    ) : (
                      <Td>
                        <HorizontalContent>
                          $
                          <input
                            type="Number"
                            onWheel={e => e.target.blur()}
                            value={price}
                            defaultValue={price}
                            placeholder="One-Time Price"
                            className="frg-input-field color-light"
                            style={{ width: '100%' }}
                            disabled
                          />
                        </HorizontalContent>
                      </Td>
                    )}
                    {priceType === 'oneTime' ? (
                      <TdImp />
                    ) : (
                      <Td>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <HorizontalContent>
                            $
                            <input
                              type="Number"
                              onWheel={e => e.target.blur()}
                              value={price}
                              placeholder="Recurring Price"
                              className="frg-input-field color-light"
                              style={{ width: '100%' }}
                              disabled
                            />
                          </HorizontalContent>
                        </div>
                      </Td>
                    )}
                    <Td>
                      <input
                        type="Number"
                        onWheel={e => e.target.blur()}
                        value={quantity}
                        placeholder={quantity}
                        className="frg-input-field color-light"
                        style={{ width: '100%' }}
                        disabled
                      />
                    </Td>
                  </Tr>
                );
              }
            )}
          </Table>
        </>
      );
    } else if (fields.type === 'MCPopup') {
      if (orderData.ocdrProductAdd.selections.length > 0) {
        return (
          <Table>
            <Th>Product</Th>
            <Th>Monthly Charges</Th>
            <Th>Monthly Discount(%)</Th>
            <Th>OneTime Charge</Th>
            <Th>Onetime Discount(%)</Th>
            <Th>Quantity</Th>
            {/* Add this column for edit/delete buttons */}
            {orderData.ocdrProductAdd.selections.map(
              (
                {
                  sku,
                  editions,
                  quantity,
                  monthlyCharges,
                  monthlyDiscount,
                  oneTimeCharge,
                  onetimeDiscount
                },
                idx
              ) => (
                // eslint-disable-next-line react/no-array-index-key
                <Tr key={`${oneTimeCharge}-${monthlyCharges}-${idx}`}>
                  <Td>{`${editions},${sku}`}</Td>
                  <Td>${monthlyCharges}</Td>
                  <Td>{monthlyDiscount}%</Td>
                  <Td>${oneTimeCharge}</Td>
                  <Td>{onetimeDiscount}%</Td>
                  <Td>{quantity}</Td>
                  {/* <Td>{formatCurrency(totalCost)}</Td>
                <Td>{formatCurrency(totalPrice)}</Td> */}
                </Tr>
              )
            )}
            <Tr>
            <TdLabel colSpan={1}>Total</TdLabel>
            <TdImp>{formatCurrency(orderData.ocdrProductAdd.adjustedTotalPrice.totalMonthlyPrice)}</TdImp>
            <Td></Td>
            <TdImp>{formatCurrency(orderData.ocdrProductAdd.adjustedTotalPrice.totalOneTimePrice)}</TdImp>
          </Tr>
          <Tr>
            <TdLabel colSpan={1}>Total with Discount</TdLabel>
            <TdImp>{formatCurrency(orderData.ocdrProductAdd.adjustedTotalPriceDiscount.totalMonthlyPriceDiscount)}</TdImp>
            <Td></Td>
            <TdImp>{formatCurrency(orderData.ocdrProductAdd.adjustedTotalPriceDiscount.totalOneTimePriceDiscount)}</TdImp>
          </Tr>
          </Table>
        );
      }
    } else {
      return (
        <FormSummaryRow
          key={fields.name}
          label={fields.label}
          value={get(orderData, fields.name)}
          isDollarRemove
        />
      );
    }
  });
};

export default Services;
